import { render, staticRenderFns } from "./ShiftBoardList.vue?vue&type=template&id=519270b7&scoped=true"
import script from "./ShiftBoardList.vue?vue&type=script&lang=js"
export * from "./ShiftBoardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519270b7",
  null
  
)

export default component.exports